import { useTranslate } from '@prenuvo/halo';

import {
  ActivityLogDetailValue,
  FullObject as FullObjectModel,
  NormaliseCheck as NormaliseCheckModel,
  ReportFindingConditionDetail,
} from '@/api';
import { useIsDDFeatureFlagEnabled } from '@/core/data-dog';

import { ActionClass, IGNORED_FIELDS } from '../activity-log.constant';
import { generateTitle } from '../activity-log.util';
import { ActivityLogDetail } from '../activity-log-detail.component';
import { ConditionDetail } from '../condition-detail.component';
import { CustomNormals } from './custom-normals.component';
import { NormaliseCheck } from './normalise-check.component';

interface FullObjectProps {
  action: ActionClass;
  fullObject: FullObjectModel | null;
}

export function FullObject({ action, fullObject }: FullObjectProps) {
  const translate = useTranslate();

  const isConditionTemplateDisplayNameEnabled = useIsDDFeatureFlagEnabled(
    'FCT_CONDITION_TEMPLATE_DISPLAY_NAME',
  );

  return (
    <div className="pt-2">
      {fullObject &&
        Object.entries(fullObject).map(([key, value]) => {
          if (key === 'conditionDetail' && Array.isArray(value)) {
            return fullObject[key]?.map((conditionDetail: ReportFindingConditionDetail) => (
              <ConditionDetail
                key={conditionDetail.name}
                action={action}
                conditionDetail={conditionDetail}
                fieldName={conditionDetail.name}
                fullObject={fullObject}
              />
            ));
          }

          if (key === 'normaliseCheck') {
            return (
              <NormaliseCheck
                key={key}
                action={action}
                item={key}
                normaliseObject={fullObject[key] as NormaliseCheckModel}
              />
            );
          }

          if (key === 'customNormals') {
            return (
              <CustomNormals
                key={key}
                action={action}
                customNormalsObject={fullObject[key] as Record<string, string>}
                item={key}
              />
            );
          }

          if (key === 'descriptionOfCall' || key === 'reasonForAccessingPtInfo') {
            return (
              <ActivityLogDetail
                key={key}
                action={action}
                fieldName={key}
                title={
                  translate(
                    key === 'descriptionOfCall'
                      ? 'FCT.ACTIVITY_LOGS.DESCRIPTION_OF_CALL'
                      : 'FCT.ACTIVITY_LOGS.REASON_FOR_PT_INFO',
                  ) as string
                }
                value={value as ActivityLogDetailValue}
              />
            );
          }

          if (!IGNORED_FIELDS.includes(key) && (value || value === 0)) {
            return (
              <ActivityLogDetail
                key={key}
                action={action}
                fieldName={key}
                title={generateTitle(key, null, isConditionTemplateDisplayNameEnabled)}
                value={value as ActivityLogDetailValue}
              />
            );
          }

          return null;
        })}
    </div>
  );
}
